module.exports = __webpack_public_path__ + "fonts/NouvelR-Light.5b2bb834.ttf";